<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
	></app-nav-gestion-donnees>

	<div class="row my-3">
		<div class="row my-2">
			<div class="col-2 ms-auto">
				<div class="dropdown">
					<a
						class="btn btn-secondary dropdown-toggle"
						role="button"
						id="dropdownFilter"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
					>
						<i class="bi bi-filter" aria-hidden="true"></i> Filtrer
					</a>
					<div
						class="dropdown-menu px-3 py-3 vw-30"
						aria-labelledby="dropdownFilter"
						id="menuFilter"
					>
						<div class="row container">
							<span class="theme-main-color form-label">Status :</span>
							<div class="">
								<div
									*ngFor="let status of vehiculeStatus | keyvalue"
									class="form-check"
								>
									<input
										(change)="changeStatusFilter($event, status.key)"
										class="form-check-input"
										type="checkbox"
										value="{{ status.key }}"
										id="dd{{ status.key }}"
									/>
									<label class="form-check-label" for="dd{{ status.key }}">
										{{ status.value }}
									</label>
								</div>
							</div>
						</div>
						<div class="row container">
							<span class="theme-main-color form-label"
								>Distance parcourue :</span
							>

							<div class="row">
								<div class="col-3">
									<span class=""> À partir de </span>
								</div>
								<input
									type="number"
									class="col-3"
									[(ngModel)]="minTravelledDistance"
								/>
								<div class="col-3 text-center">jusqu'à</div>
								<input
									type="number"
									class="col-3"
									[(ngModel)]="maxTravelledDistance"
								/>
							</div>
						</div>
						<div class="row container">
							<span class="theme-main-color form-label"
								>Coût kilométrique :</span
							>

							<div class="row">
								<div class="col-3">
									<span class=""> À partir de </span>
								</div>
								<input
									type="number"
									class="col-3"
									[(ngModel)]="minMileageCost"
								/>
								<div class="col-3 text-center">jusqu'à</div>
								<input
									type="number"
									class="col-3"
									[(ngModel)]="maxMileageCost"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-3">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Recherche un élément..."
						[(ngModel)]="searchedText"
					/>
				</div>
			</div>
		</div>

		<div class="row mb-4 mt-1">
			<div class="col-2">
				<span class="ps-1 hand-cursor" (click)="sortChange('name')">
					Nom
					<span
						*ngIf="sortType === 'name' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'name' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2">
				<span class="ps-1 hand-cursor" (click)="sortChange('model')">
					Modèle
					<span
						*ngIf="sortType === 'model' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'model' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2">
				<span class="ps-1 hand-cursor" (click)="sortChange('centerDepartment')">
					Service
					<span
						*ngIf="sortType === 'centerDepartment' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'centerDepartment' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2">
				<span class="ps-1 hand-cursor" (click)="sortChange('status')">
					Status
					<span
						*ngIf="sortType === 'status' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'status' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2">
				<span
					class="ps-1 hand-cursor"
					(click)="sortChange('travelledDistance')"
				>
					Distance parcourue
					<span
						*ngIf="sortType === 'travelledDistance' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'travelledDistance' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2">
				<span class="ps-1 hand-cursor" (click)="sortChange('mileageCost')">
					Coût kilométrique
					<span
						*ngIf="sortType === 'mileageCost' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'mileageCost' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
		</div>

		<div class="row mt-4">
			<div
				*ngFor="
					let vehicule of vehicules
						| filterVehiculeByAllFields : searchedText
						| filterVehiculeByTravelledDistanceBetween
							: minTravelledDistance
							: maxTravelledDistance
						| filterVehiculeByMileageBetween : minMileageCost : maxMileageCost
						| filterVehiculeByStatus : selectedStatus
						| paginate : { itemsPerPage: 8, currentPage: currentPage }
						| orderBy : sortType : sortOrder
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3 bg-light"
			>
				<span class="col-2">{{ vehicule.name }}</span>
				<span class="col-2">{{ vehicule.model }}</span>
				<span class="col-2">{{ vehicule.centerDepartment.name }}</span>
				<span class="col-2">{{ vehiculeStatus[vehicule.status] }}</span>
				<span class="col-2 text-center"
					>{{ vehicule.travelledDistance }} km</span
				>
				<div class="col-2 text-center">
					<div class="d-flex">
						<span class="flex-grow-1">{{ vehicule.mileageCost }} €</span>
						<i
							[routerLink]="['/gestion/vehicules', vehicule.id]"
							role="button"
							class="fs-4 bi bi-caret-right-fill mb-1"
							aria-hidden="true"
						></i>
					</div>
				</div>
			</div>
		</div>

		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			></pagination-controls>
		</div>
	</div>
</div>

<!-- <div class="card border-primary mb-3">
    <div class="card-body">
        <div class="row mb-3">
            <div class="col-6">
                <button
                    type="button"
                    class="btn btn-primary mr-2"
                    routerLink="/vehicules/add"
                >
                    Ajouter un véhicule
                </button>
            </div>
        </div>
    </div>
</div>
<h4 class="section_header" style="text-align: center">Liste des véhicules</h4>
<table class="table w-100" data-pagination="true">
    <thead>
        <tr class="text-center">
            <th scope="col">#</th>
            <th scope="col">Véhicule</th>
            <th scope="col">Statut</th>
            <th scope="col">Location</th>
            <th scope="col">GPS intégré</th>
            <th scope="col">Distance parcourue</th>
            <th scope="col">Coût kilométrique</th>
        </tr>
    </thead>
    <tbody class="table table-striped">
        <tr
            class="text-center"
            role="button"
            *ngFor="
                let vehicule of vehicules
                    | paginate: { itemsPerPage: 8, currentPage: currentPage }
            "
            (click)="selectVehicule(vehicule)"
        >
            <th scope="row">{{ vehicule?.id }}</th>
            <td>{{ vehicule?.name }}</td>
            <td>
                <span
                    class="badge font-size-increased"
                    [ngClass]="
                        vehicule?.status === 'Disponible'
                            ? 'badge-success'
                            : vehicule?.status === 'En utilisation'
                            ? 'badge-warning'
                            : 'badge-danger'
                    "
                >
                    {{ vehicule?.status }}
                </span>
            </td>

            <td>
                <span *ngIf="vehicule?.rented">
                    <fa-icon class="mr-1" [icon]="faCheck"></fa-icon>
                </span>
            </td>

            <td>
                <span *ngIf="vehicule?.gps">
                    <fa-icon class="mr-1" [icon]="faCheck"></fa-icon>
                </span>
            </td>

            <td>{{ vehicule?.travelledDistance }} km</td>
            <td>{{ vehicule?.mileageCost }} €</td>
        </tr>
    </tbody>
</table>
<pagination-controls
    class="d-flex justify-content-center"
    (pageChange)="currentPage = $event"
    previousLabel="Précédent"
    nextLabel="Suivant"
></pagination-controls> -->
